const BILLING_DATA_TYPES = {
  PERSONALID: 'personalId',
  RUT: 'rut',
  OTHER: 'other',
};

class BillingData {
  constructor(params) {
    this.id = params.id;
    this.type = params.type;
    this.name = params.name;
    this.address = params.address;
    this.locality = params.locality;
    this.department = params.department;
    if (this.type === BILLING_DATA_TYPES.RUT) {
      this.rut = params.rut;
    } else {
      this.personalId = params.personalId;
    }
  }
}

export { BillingData, BILLING_DATA_TYPES };



// WEBPACK FOOTER //
// ./src/models/BillingData.js